import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree, Router } from '@angular/router';
import { AuthService } from '../services/auth.service';
import { ToastV2Service } from '../services/toast-v2.service';

@Injectable({
  providedIn: 'root'
})
export class OrganizationAdminGuard  {

  constructor(private authService: AuthService, private router: Router, private toastService: ToastV2Service) {}

  async canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Promise<Promise<boolean | UrlTree> | boolean | UrlTree> {
      const isSuperAdmin = await this.authService.isAdmin();
      if (isSuperAdmin) {
        return true;
      }

      const organizationId = route.paramMap.get('organizationId') ?? this.authService.getCurrentOrganization();
      if (!organizationId) {
        return this.router.createUrlTree(['/dashboard']);
      }

      const isAdmin = await this.authService.isOrganizationAdmin(organizationId);
      if (!isAdmin) {
        this.toastService.callErrorToast("You're not an admin of this organization");
        return this.router.createUrlTree(['/dashboard']);
      }

      return true;
  }
}
